import React, {  useEffect } from 'react'; 
import TextField from '@mui/material/TextField';
import SearchRounded from '@mui/icons-material/SearchRounded';
import InputAdornment from '@mui/material/InputAdornment';
import Container from '@mui/material/Container'; 
import {
  useSearchParams,
  useNavigate
} from "react-router-dom";





export default function SearchBar(props:any) {
//

let [searchParams, setSearchParams] = useSearchParams();
const [openExpDialog, setOpenExpDialog] = React.useState(false);
const [expDialogData, setExpDialogData] = React.useState<any>(null);


useEffect(() => { 
  let sp = searchParams.get("filter"); 
  if(sp)
  {
      filterQueryHandler(sp);
  }

}, [])


  

  let navigate = useNavigate();

  const [searchValue, setSearchValue] = React.useState('');


  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(event.target.value);
    //console.log("--------changes:",event.target.value);
  };


  const handleKeyPress = (event: any) => {
     
    if(event.key === 'Enter')
    {
      console.log("-------Enter-",searchValue);
      navigate(`/browse?filter=${searchValue}`);
      event.preventDefault();
    }

  };

  ////////////////////

  const getCleanQueryInput = (query:string):string => {
  let cleanV = query.replace(":", " ");
  cleanV = cleanV.replaceAll("-", " ");
  cleanV = cleanV.replaceAll(",", "");
  cleanV = cleanV.replaceAll("'", ""); 
  cleanV = cleanV.replace(/\t/g, ' ');
  cleanV = cleanV.toString().trim().replace(/(\r\n|\n|\r)/g,"");    
  cleanV = cleanV.replace(/\s\s+/g, ' ');

  return cleanV;
}


const getCoordQuery = (query:string) => {
  let cleanV = getCleanQueryInput(query);
  let filterValueTokens = cleanV.split(" ");

  if(filterValueTokens.length===3 && 
      filterValueTokens[0] &&
      filterValueTokens[1] &&
      filterValueTokens[2])
  {
      console.log("2HELLO", filterValueTokens);
      
      const chrRegex = new RegExp('(chr(([1-9]|1[0-9]|2[0-2]){1}|x{1}|y{1}))$'); 
      console.log("test:", filterValueTokens[0].toLowerCase() , chrRegex.test(filterValueTokens[0].toLowerCase()));
      if(chrRegex.test(filterValueTokens[0].toLowerCase())===true)
      {
          console.log("G coord chr:", filterValueTokens[0]);
          return "coord=" + filterValueTokens[0] + "-" + filterValueTokens[1] + "-" + filterValueTokens[2];
      }
      else
      {
          return null;
      }
  }
  else
  {
      return null;
  }

}

const handleCloseExpDialog = (value: string) => {
  setOpenExpDialog(false);
};


  const filterQueryHandler = (query:string|null) => {
  if(!query)
      return;
  console.log(query);
  const vistaIDRegex = new RegExp('(hs|mm|xx)[0-9]+(.[0-9]+)?'); 
  if(vistaIDRegex.test(query)===true)
  {  
      let _vistaId:any = query;
      let _alleleId:any = 0;

      let tokens = query.split(".");
      if(tokens.length === 2)
      {
          _vistaId = tokens[0];
          _alleleId = tokens[1];
      }

      //direct to element page
      navigate(`/element?vistaId=${_vistaId}&alleleId=${_alleleId}`);  //navigate(`/element?vistaId=${query}&alleleId=0`);
      /*
      setExpDialogData({"rowData":null, "stageItem":null, vistaID:query});
      setOpenExpDialog(true);
      */
      return;
  }   
  
  let coordQuery = getCoordQuery(query); 
  console.log("------coordQuery",coordQuery);
  if(coordQuery)
  {
      props.loadData(coordQuery);
      return;
  }
    
  let geneNameQuery = getCleanQueryInput(query);  
  if(geneNameQuery)
  {
      console.log("Gene name query:", geneNameQuery);
      props.loadData("gene="+geneNameQuery);
      return;
  }

  //props.loadData(searchParams.get("filter"));
}

  return (
      
      <Container>
            <TextField
              label="Quick Search"  
              size="medium"
              value={searchValue}
              onChange={handleChange}
              onKeyPress={handleKeyPress}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">
                    <SearchRounded />
                  </InputAdornment>
                  
                ),
              }}
              style={{width:"60%", backgroundColor:"white", marginTop: "5px", marginBottom:"5px"}}
            >
            </TextField>
            <br/>
            <span style={{fontSize:"12px"}}>Enter a <b>Vista ID</b> (e.g. hs72.0 or hs2766), a <b>flanking gene name</b> (e.g. IRF8) or <b>element coordinates</b> (e.g. chr16:86396481-86397120).</span>

      </Container>
  );
}